var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_82814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 3C19.5382 3 22.0002 5.5 22.0002 9C22.0002 16 14.5002 20 12.0002 21.5C9.50018 20 2.00018 16 2.00018 9C1.95639 8.24238 2.06501 7.48367 2.3196 6.76876C2.57418 6.05385 2.96957 5.39726 3.48237 4.83785C3.99517 4.27843 4.61496 3.82755 5.30508 3.51187C5.99519 3.19619 6.74161 3.02214 7.50018 3C9.20162 3.0629 10.8133 3.77922 12.0002 5C13.187 3.77922 14.7987 3.0629 16.5002 3Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_82814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.2eac0e89d2264cb50632704dd09c2d6e.svg";
export { ForwardRef as ReactComponent };